import React, { useState, useMemo, useEffect } from "react";
import Select from "react-select";
import * as XLSX from "xlsx";
import { useSelector } from "react-redux";
import { apmcByDistrictId, getAllFiltersInMISAfterApproval, getMISheaders } from "../../../auth/services/privateapicalling";
import { 
  MISformP1, MISformP2, MISformP3, MISformP4, MISformP5, 
  MISformP6, MISformP7, MISformP8, MISformP9, MISformP10,
  MISformP11, MISformP12, MISformP13, MISformP14, MISformP15,
  MISformP16, MISformP17, MISformP18, MISformP19, MISformP20,
  MISformP21, MISformP22, MISformP23, MISformP24, MISformP25, MISformP26
} from "../../../../core/data/json/MIS_Forms";
import { getAllAPMC } from "../../../auth/services/apiCalling";
import { toast } from "react-toastify";

/* -------------------- TYPES -------------------- */
interface SelectOption {
  value: string;
  label: string;
  other?: any;
}

interface HeaderData {
  id: string;
  header_name: string;
  priority: string | null;
}

interface ApplicationDetail {
  id: string;
  masterId: string;
  [key: string]: any;
}

interface ApplicationData {
  applicationId: string;
  apmcName: string;
  createdAt: string;
  year: string;
  districtId: string;
  appStatusLevel: string;
  status: string;
  details: ApplicationDetail[];
  sourceTable: string;
}

/* -------------------- COMPONENT -------------------- */
const MarketCommitteeDashboard: React.FC = () => {
  const [selectedHeader, setSelectedHeader] = useState<SelectOption[]>([]);
  // const [selectedYear, setSelectedYear] = useState<SelectOption[]>([]);
  const [selectedTaluka, setSelectedTaluka] = useState<SelectOption[]>([]);
  const [selectedCommittee, setSelectedCommittee] = useState<SelectOption[]>([]);
  const [selectedDistricts, setSelectedDistricts] = useState<SelectOption[]>([]);
  const [selectedAPMCs, setSelectedAPMCs] = useState<SelectOption[]>([]);
  const [districtOptions, setDistrictOptions] = useState<SelectOption[]>([]);
  const [apmcData, setApmcData] = useState<SelectOption[]>([]);

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  
  // API State
  const [headers, setHeaders] = useState<HeaderData[]>([]);
  const [dashboardData, setDashboardData] = useState<ApplicationData[]>([]);
  const [loading, setLoading] = useState(false);
  const [hasAppliedFilter, setHasAppliedFilter] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});

  const token = useSelector((state: any) => state.auth.token);
  const districtId = useSelector((state: any) => state.auth.districtId || "");

  const getDataFieldByHeaderId = (headerId: string) => {
  switch (headerId) {
    case "f8dd542e-637b-48a9-9579-c51d955958f6":
      return MISformP1;
    case "ff834af9-ec91-4b64-be9d-8d6431318d60":
      return MISformP2;
    case "03272304-d1c1-4de3-80d5-41cc38d92c4e":
      return MISformP3;
    case "4e3264d9-5849-48c2-adb8-8f365ca9b619":
      return MISformP4;
    case "d662fb80-e724-4295-84a7-2335043045e6":
      return MISformP5;
    case "4abc0a84-c79c-487e-9459-d5bfda288209":
      return MISformP6;
    case "3542455a-a9fe-44cb-b582-bc6645cabd13":
      return MISformP7;
    case "60f185c0-0e2f-45e8-8589-0ee7c5b30720":
      return MISformP8;
    case "e8e3723e-fc9c-42a8-8e93-8003fdfa384f":
      return MISformP9;
    case "19f2c32b-8727-4c56-bb5f-f2ddab040130":
      return MISformP10;
    case "c34fc166-a42d-4c35-9ce7-caf23b63cc38":
      return MISformP11;
    case "26d4a5d5-5ca2-4188-8469-1add4e7b798f":
      return MISformP12;
    case "03f686ae-0289-4567-abe4-611f054fc460":
      return MISformP13;
    case "1be7aa2e-c4b4-4eaf-8a39-714ee69751ca":
      return MISformP14;
    case "49bb7b6e-2c1d-46c5-90ef-d74d63b323f0":
      return MISformP15;
    case "d3732eaf-9f80-4fc3-8431-e53951c21e2a":
      return MISformP16;
    case "d1ac3935-3f20-4740-9538-f6a641a75496":
      return MISformP17;
    case "5985a467-617e-4feb-a33f-f40f947f2c0e":
      return MISformP18;
    case "f0a5a49e-a89f-4536-88d7-4a5ac74a4a1a":
      return MISformP19;
    case "204d4e1b-e3da-4bea-b011-c00de370ee82":
      return MISformP20;
    case "f1abc58d-2016-477e-92bf-ad2a68c83bc8":
      return MISformP21;
    case "ccbd3a6c-80ec-4d9b-a3a0-ee0461f428a7":
      return MISformP22;
    case "e793e2b8-7f7c-489d-91af-70cbd2af1b3a":
      return MISformP23;
    case "2e9b4f1d-2cd3-4f18-89a3-c1cf54edf005":
      return MISformP24;
    case "cc5c3eda-4bb2-422e-a540-18e3c1e4ff57":
      return MISformP25;
    case "35871e1f-26bc-4c6c-82cd-c5b8be6561f7":
      return MISformP26;
    default:
      return [];
  }
};

// Map sourceTable names to their corresponding header IDs
const getHeaderIdBySourceTable = (sourceTable: string): string => {
  const tableToHeaderMap: Record<string, string> = {
    "aPMCRepStatusOfRegulatedMarketsMaster": "f8dd542e-637b-48a9-9579-c51d955958f6",
  "aPMCRepMarketCommitteeIncAndExpFlowStmtMaster": "ff834af9-ec91-4b64-be9d-8d6431318d60",
  "aPMCRepFinAssistanceLoanPremFundOfDailyMarketMaster": "03272304-d1c1-4de3-80d5-41cc38d92c4e",
  "aPMCRepDetailsofincSalesMarketMaster": "4e3264d9-5849-48c2-adb8-8f365ca9b619",
  "aPMCRepTradeDetailsDoneByCooperativeAndTradersMaster": "d662fb80-e724-4295-84a7-2335043045e6",
  "aPMCRepLicenseMarketCommitteMaster": "4abc0a84-c79c-487e-9459-d5bfda288209",
  "aPMCRepStatsApmcThreeYearMaster": "3542455a-a9fe-44cb-b582-bc6645cabd13",
  "aPMCRepIncSalePriceRegulatedComidtyMaster": "60f185c0-0e2f-45e8-8589-0ee7c5b30720",
  "aPMCRepMonthlyPriceControlledComidtyMaster": "e8e3723e-fc9c-42a8-8e93-8003fdfa384f",
  "aPMCRepDevlopCarriedByAPMCMaster": "19f2c32b-8727-4c56-bb5f-f2ddab040130",
  "aPMCRepfacilitiesByMarketCommityMaster": "c34fc166-a42d-4c35-9ce7-caf23b63cc38",
  "aPMCRepStudyTripsMemberMaster": "26d4a5d5-5ca2-4188-8469-1add4e7b798f",
  "aPMCRepDonationByAPMCMaster": "03f686ae-0289-4567-abe4-611f054fc460",
  "aPMCRepComplaintFiledByAPMCMaster": "1be7aa2e-c4b4-4eaf-8a39-714ee69751ca",
  "aPMCRepNoInstitutionServingMarketCommitteMaster": "49bb7b6e-2c1d-46c5-90ef-d74d63b323f0",
  "aPMCRepYardsalesMarketCommitteMaster": "d3732eaf-9f80-4fc3-8431-e53951c21e2a",
  "aPMCRepAPMCDetailsMaster": "d1ac3935-3f20-4740-9538-f6a641a75496",
  "aPMCRepDetailsOfCommodityControlledMaster": "5985a467-617e-4feb-a33f-f40f947f2c0e",
  "aPMCRepIncDistrictMarketCommitteMaster": "f0a5a49e-a89f-4536-88d7-4a5ac74a4a1a",
  "aPMCRepThreeYrLicenseTraderCoopMaster": "204d4e1b-e3da-4bea-b011-c00de370ee82",
  "aPMCRepBuyingSellingCommodityMaster": "f1abc58d-2016-477e-92bf-ad2a68c83bc8",
  "aPMCRepIncSalesFiveYrCommodityMaster": "ccbd3a6c-80ec-4d9b-a3a0-ee0461f428a7",
  "aPMCRepMajorInfraFacilitiesAvailableMaster": "e793e2b8-7f7c-489d-91af-70cbd2af1b3a",
  "aPMCRepStateMarketMainInfraFacilityMaster": "2e9b4f1d-2cd3-4f18-89a3-c1cf54edf005",
  "aPMCRepClassifyGheeSpicesMaster": "cc5c3eda-4bb2-422e-a540-18e3c1e4ff57",
  "aPMCRepClassificationProdLevelMaster": "35871e1f-26bc-4c6c-82cd-c5b8be6561f7",
  };
  
  return tableToHeaderMap[sourceTable] || "";
};



  // Fetch headers on mount
  useEffect(() => {
    const fetchHeaders = async () => {
      try {
        const response = await getMISheaders(token);
        if (response.success) {
          setHeaders(response.data);
        }
      } catch (error) {
      
      }
    };
    
    if (token) {
      fetchHeaders();
      fetchDistrict();
    }
  }, [token]);

  // Extract unique options from headers
const headerOptions: SelectOption[] = useMemo(
  () => [
    { value: 'all', label: 'All' },   // ✅ Add this
    ...headers.map((h) => ({
      value: h.id,
      label: h.header_name,
    })),
  ],
  [headers]
);

  const handleApplyFilters = async () => {
  if (selectedHeader.length === 0) {
    toast.error("Please select at least one Report Type and Date Range");
    return;
  }

  setLoading(true);
  setIsFilterOpen(false);

  try {
    const headerIds = selectedHeader.map(h => h.value).join(',');
    const selectedDistrictId = selectedDistricts.length > 0 
      ? selectedDistricts.map(d => d.value).join(',')
      : districtId; // fallback to default districtId
    
const response = await getAllFiltersInMISAfterApproval(
  selectedDistrictId,
  headerIds,
  0,
  100,
  dateFrom ? `${dateFrom}T00:00:00.000Z` : '',
  dateTo ? `${dateTo}T23:59:59.999Z` : '',
  token,
  selectedAPMCs.length > 0
    ? selectedAPMCs.map(a => a.label).join(',')
    : ''
);


    if (response.success) {
      setDashboardData(response.data);
      setHasAppliedFilter(true);
    }
  } catch (error) {
    
    toast.error("Failed to fetch data. Please try again.");
  } finally {
    setLoading(false);
  }
};



  const fetchDistrict = async () => {
  try {
    const response = await getAllAPMC(token, '', '');
    const districts = response.data.map((d) => ({
      label: d.District,
      value: d.district_id,
    }));
    setDistrictOptions(districts);
  } catch (error) {
   
  }
};

const fetchApmcId = async (districtIds: string[]) => {
  if (!districtIds || districtIds.length === 0) {
    setApmcData([]);
    return;
  }

  const payload = {
    districtIds: districtIds
  };
  
  try {
    const res = await apmcByDistrictId(payload, token);
    let newData = res.data
    .filter((item: any) => item.apmcName && item.apmcName.trim() !== "")
    .map((item: any) => ({
      value: item.id,
      label: item.apmcName,
      other: {
        ...item,
        district_id: item.district_id
      }
    }));
    setApmcData(newData);
  } catch (error) {
   
    setApmcData([]);
  }
};

const handleDistrictChange = (selected: any) => {
  if (!selected || selected.length === 0) {
    setSelectedDistricts([]);
    setSelectedAPMCs([]);
    setApmcData([]);
    fetchApmcId([]);
    return;
  }

  const isSelectAll = selected.some((opt: any) => opt.value === "select_all");

  if (isSelectAll) {
    if (selectedDistricts.length === districtOptions.length) {
      setSelectedDistricts([]);
      setSelectedAPMCs([]);
      setApmcData([]);
      fetchApmcId([]);
    } else {
      const allDistricts = [...districtOptions];
      setSelectedDistricts(allDistricts);
      const dataArr = allDistricts.map((item) => item.value);
      fetchApmcId(dataArr);
    }
  } else {
    const newDistrictIds = selected.map((item: any) => item.value);
    const previousDistrictIds = selectedDistricts.map((item: any) => item.value);
    
    const removedDistrictIds = previousDistrictIds.filter(
      id => !newDistrictIds.includes(id)
    );
    
    if (removedDistrictIds.length > 0) {
      const filteredAPMCs = selectedAPMCs.filter(apmc => 
        !removedDistrictIds.includes(apmc.other?.district_id)
      );
      setSelectedAPMCs(filteredAPMCs);
      
      const filteredApmcData = apmcData.filter((apmc: any) => 
        !removedDistrictIds.includes(apmc.other?.district_id)
      );
      setApmcData(filteredApmcData);
    }
    
    setSelectedDistricts(selected);
    fetchApmcId(newDistrictIds);
  }
};

const handleAPMCChange = (selected: any) => {
  setSelectedAPMCs(selected || []);
  
  if (errors.apmcs && selected && selected.length > 0) {
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors.apmcs;
      return newErrors;
    });
  }
};



const districtOptionsWithSelectAll = useMemo(() => {
  return [
    { value: "select_all", label: "Select All Districts" },
    ...districtOptions,
  ];
}, [districtOptions]);

const apmcOptionsWithSelectAll = useMemo(() => {
  return [
    { value: "select_all", label: "Select All APMCs" },
    ...apmcData,
  ];
}, [apmcData]);

  // Extract talukas and committees from dashboard data
  const talukaOptions: SelectOption[] = useMemo(() => {
    const talukas = new Set<string>();
    dashboardData.forEach((app) => {
      app.details.forEach((detail) => {
        if (detail.talukasCovered) {
          talukas.add(detail.talukasCovered);
        }
      });
    });
    return Array.from(talukas)
      .sort()
      .map((t) => ({ value: t, label: t }));
  }, [dashboardData]);

  const committeeOptions: SelectOption[] = useMemo(() => {
    const committees = new Set<string>();
    dashboardData.forEach((app) => {
      app.details.forEach((detail) => {
        if (detail.nameOfMarketCommittee) {
          committees.add(detail.nameOfMarketCommittee);
        } else if (detail.marketCommitteeName) {
          committees.add(detail.marketCommitteeName);
        } else if (detail.committeeName) {
          committees.add(detail.committeeName);
        }
      });
    });
    return Array.from(committees)
      .sort()
      .map((c) => ({ value: c, label: c }));
  }, [dashboardData]);

  // Apply Filters - Fetch data from API


  // Filter data based on local filters (taluka, committee, search)
  const filteredData = useMemo(() => {
    if (!hasAppliedFilter) return [];

    return dashboardData.filter((app) => {
      // Filter details within each application
      const filteredDetails = app.details.filter((detail) => {
        const matchesTaluka = selectedTaluka.length === 0 || 
          selectedTaluka.some(t => detail.talukasCovered === t.value);
        
        const committeeName = detail.nameOfMarketCommittee || detail.marketCommitteeName || detail.committeeName;
        const matchesCommittee = selectedCommittee.length === 0 || 
          selectedCommittee.some(c => committeeName === c.value);
        
        const matchesSearch = !searchQuery || 
          Object.values(detail).some(val => 
            val && val.toString().toLowerCase().includes(searchQuery.toLowerCase())
          );
        
        return matchesTaluka && matchesCommittee && matchesSearch;
      });

      return filteredDetails.length > 0;  // ✅ Removed year check
    }).map(app => ({
      ...app,
      details: app.details.filter((detail) => {
        const matchesTaluka = selectedTaluka.length === 0 || 
          selectedTaluka.some(t => detail.talukasCovered === t.value);
        
        const committeeName = detail.nameOfMarketCommittee || detail.marketCommitteeName || detail.committeeName;
        const matchesCommittee = selectedCommittee.length === 0 || 
          selectedCommittee.some(c => committeeName === c.value);
        
        const matchesSearch = !searchQuery || 
          Object.values(detail).some(val => 
            val && val.toString().toLowerCase().includes(searchQuery.toLowerCase())
          );
        
        return matchesTaluka && matchesCommittee && matchesSearch;
      })
    }));
  }, [dashboardData, selectedTaluka, selectedCommittee, searchQuery, hasAppliedFilter]); // ✅ Removed selectedYear dependency
const clearAllFilters = () => {
  setSelectedHeader([]);
  setSelectedDistricts([]);
  setSelectedAPMCs([]);
  setSelectedTaluka([]);
  setSelectedCommittee([]);
  setDateFrom("");
  setDateTo("");
  setSearchQuery("");
  setDashboardData([]);
  setHasAppliedFilter(false);
  setApmcData([]);
};

const hasAnyFilter = selectedHeader.length > 0 || selectedDistricts.length > 0 || selectedAPMCs.length > 0 || selectedTaluka.length > 0 || selectedCommittee.length > 0 || searchQuery || dateFrom || dateTo;
  const hasData = filteredData.length > 0 && filteredData.some(app => app.details.length > 0);

  // Group data by source table for rendering
const groupedByTable = useMemo(() => {
  const grouped: Record<string, { 
    details: ApplicationDetail[], 
    headerId: string,
    headerName: string 
  }> = {};
  
  filteredData.forEach((app) => {
    const tableName = app.sourceTable;
    
    // Get the correct header ID for this source table
    const tableHeaderId = getHeaderIdBySourceTable(tableName);
    
    // Find the header name from the headers list
    const headerInfo = headers.find(h => h.id === tableHeaderId);
    
    if (!grouped[tableName]) {
      grouped[tableName] = {
        details: [],
        headerId: tableHeaderId,
        headerName: headerInfo?.header_name || tableName.replace(/([A-Z])/g, ' $1').trim()
      };
    }
    grouped[tableName].details.push(...app.details);
  });
  
  return grouped;
}, [filteredData, headers]);

const downloadAsExcel = () => {
  const generatedOn = new Date().toLocaleString();

  /* ===============================
     Helper: Calculate column count
  =============================== */
  const getTotalColumns = (misForm: any[]) => {
    let count = 1; // Sr. No.
    misForm.forEach(field => {
      count += field.response?.length || 1;
    });
    return count;
  };

  /* ===============================
     Find max columns for header
  =============================== */
  const maxColumns = Math.max(
    ...Object.values(groupedByTable).map((tableData: any) => {
      const form = getDataFieldByHeaderId(tableData.headerId);
      return form?.length ? getTotalColumns(form) : 1;
    })
  );

  let html = `
  <html>
  <head>
    <meta charset="UTF-8" />
    <title>APMC MIS Report</title>

    <style>
      body {
        font-family: Calibri, Arial, sans-serif;
        font-size: 13px;
        color: #000;
      }

      table {
        border-collapse: collapse;
        width: 100%;
        margin-bottom: 24px;
      }

      th, td {
        border: 1px solid #dee2e6;
        padding: 8px;
        vertical-align: middle;
      }

      th {
        background-color: #0d6efd;
        color: #ffffff;
        font-weight: 600;
        text-align: center;
      }

      .sub-header th {
        background-color: #cfe2ff;
        color: #000;
      }

      tbody tr:nth-child(even) td {
        background-color: #f8f9fa;
      }

      .report-title {
        font-size: 18px;
        font-weight: 700;
        background-color: #0b5ed7;
        color: #ffffff;
        padding: 14px;
      }

      .report-subtitle {
        font-size: 12px;
        background-color: #e7f1ff;
        padding: 8px;
      }

      .section-title {
        background-color: #e9ecef;
        font-size: 16px;          /* BIGGER TEXT */
        font-weight: 700;
        padding: 12px;            /* More height */
      }

      .text-center {
        text-align: center;
      }
    </style>
  </head>

  <body>

    <!-- MAIN REPORT HEADER -->
    <table>
      <tr>
        <td class="report-title" colspan="${maxColumns}">
          AGRICULTURAL PRODUCE MARKET COMMITTEES<br/>
          MANAGEMENT INFORMATION SYSTEM (MIS) REPORT
        </td>
      </tr>
      <tr>
        <td class="report-subtitle" colspan="${maxColumns}">
          Generated On: ${generatedOn}<br/>
          Filters: ${selectedHeader.map(h => h.label).join(', ') || 'All'}
          &nbsp; | &nbsp;
          Date Range: ${dateFrom || '-'} to ${dateTo || '-'}
        </td>
      </tr>
    </table>
  `;

  /* ===============================
     Tables Section
  =============================== */
  Object.entries(groupedByTable).forEach(([_, tableData]: any) => {
    if (!tableData.details?.length) return;

    const misForm = getDataFieldByHeaderId(tableData.headerId);
    if (!misForm?.length) return;

    const totalColumns = getTotalColumns(misForm);

    html += `
    <table>
      <tr>
        <td class="section-title" colspan="${totalColumns}">
          ${tableData.headerName} (Total Records: ${tableData.details.length})
        </td>
      </tr>

      <tr>
        <th rowspan="2">Sr. No.</th>
    `;

    /* Main headers */
    misForm.forEach(field => {
      const colspan = field.response.length > 1 ? field.response.length : 1;
      const rowspan = field.response.length === 1 ? 2 : 1;
      html += `<th colspan="${colspan}" rowspan="${rowspan}">${field.fieldVal}</th>`;
    });

    html += `</tr>`;

    /* Sub headers */
    html += `<tr class="sub-header">`;
    misForm.forEach(field => {
      if (field.response.length > 1) {
        field.response.forEach(resp => {
          html += `<th>${resp.responseName}</th>`;
        });
      }
    });
    html += `</tr>`;

    /* Data rows */
    tableData.details.forEach((item: any, idx: number) => {
      html += `<tr><td class="text-center">${idx + 1}</td>`;

      misForm.forEach(field => {
        field.response.forEach(resp => {
          let value = item[resp.fieldName];

          if (typeof value === "boolean") value = value ? "Yes" : "No";
          if (value === null || value === undefined || value === "") value = "-";

          html += `<td>${value}</td>`;
        });
      });

      html += `</tr>`;
    });

    html += `</table>`;
    html += `
    <table>
      <tr>
        <td colspan="${totalColumns}" style="height: 20px; border: none;"></td>
      </tr>
    </table>
    `;
  });

  html += `</body></html>`;

  /* ===============================
     Download
  =============================== */
  const blob = new Blob([html], { type: "application/vnd.ms-excel" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `APMC-MIS-Report-${new Date().toISOString().split("T")[0]}.xls`;
  link.click();

  URL.revokeObjectURL(url);
};




  return (
    <div className="container-fluid p-4 bg-light min-vh-100">
      <div className="bg-white rounded shadow-sm p-4 mb-4">
        <div className="d-flex flex-column gap-4">
          <div>
            <h2 className="text-dark">Agricultural Market Committee Dashboard</h2>
            <p className="text-muted small mb-0">Comprehensive market committee reports and data management</p>
          </div>
          
          <div className="d-flex gap-3 justify-content-between align-items-center">
            <button
              className={`btn d-flex align-items-center ${isFilterOpen ? "btn-info" : "btn-outline-info"}`}
              onClick={() => setIsFilterOpen(!isFilterOpen)}
            >
              <i className="bi bi-funnel me-2"></i>
              Filters
              {isFilterOpen ? <i className="bi bi-chevron-up ms-2"></i> : <i className="bi bi-chevron-down ms-2"></i>}
            </button>

            <div className="input-group w-75">
              <span className="input-group-text bg-white">
                <i className="feather feather-search"></i>
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Search by Committee, Taluka, or Content"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <div className="d-flex gap-2">
              <button 
                className="btn btn-outline-success d-flex align-items-center" 
                onClick={downloadAsExcel}
                disabled={!hasData}
                title="Download as Excel"
              >
                {/* <i className="bi bi-file-earmark-excel me-2"></i> */}
                Download Excel
              </button>
            </div>
          </div>
        </div>

        {isFilterOpen && (
          <>
            <div
              className="position-fixed top-0 start-0 w-100 vh-100 bg-dark bg-opacity-50"
              style={{ zIndex: 1040 }}
              onClick={() => setIsFilterOpen(false)}
            />

            <div
              className="position-fixed top-50 start-50 translate-middle bg-white rounded shadow-lg p-4"
              style={{ width: "50vw", maxHeight: "85vh", overflowY: "auto", zIndex: 1050 }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0 fw-bold">Filter Reports</h6>
                <button type="button" className="btn-close" onClick={() => setIsFilterOpen(false)} />
              </div>

             <div className="mb-4">
  <h6 className="text-muted small mb-3">Report Type *</h6>
  <Select
    isMulti
    value={selectedHeader}
    onChange={(selected) => setSelectedHeader(selected as SelectOption[])}
    options={headerOptions}
    placeholder="Select Report(s)"
    className="basic-multi-select"
  />
</div>

<div className="mb-4">
  <h6 className="text-muted small mb-3">Location</h6>
  <div className="row g-3">
    <div className="col-md-6">
      <label className="form-label fw-semibold small">District</label>
      <Select
        isMulti
        value={selectedDistricts}
        onChange={handleDistrictChange}
        options={districtOptionsWithSelectAll}
        placeholder="Select District(s)"
        className="basic-multi-select"
      />
    </div>

    <div className="col-md-6">
      <label className="form-label fw-semibold small">APMC</label>
      <Select
        isMulti
        value={selectedAPMCs}
        onChange={handleAPMCChange}
        options={apmcData}
        placeholder="Select APMC(s)"
        className="basic-multi-select"
        isDisabled={selectedDistricts.length === 0}
      />
    </div>
  </div>
</div>

<div className="mb-4">
  <h6 className="text-muted small mb-3">Date Range *</h6>
  <div className="row g-3">
    <div className="col-md-6">
      <label className="form-label fw-semibold small">From Date</label>
      <input
        type="date"
        className="form-control"
        value={dateFrom}
        onChange={(e) => setDateFrom(e.target.value)}
      />
    </div>

    <div className="col-md-6">
      <label className="form-label fw-semibold small">To Date</label>
      <input
        type="date"
        className="form-control"
        value={dateTo}
        onChange={(e) => setDateTo(e.target.value)}
      />
    </div>
  </div>
</div>

              <div className="d-flex justify-content-between align-items-center pt-3 border-top">
                <button
                  className="btn btn-link p-0 text-decoration-none"
                  onClick={clearAllFilters}
                  disabled={!hasAnyFilter}
                >
                  Clear All
                </button>

                <div className="d-flex align-items-center gap-2">
                  {hasAnyFilter && (
                    <span className="badge bg-secondary">
                    {[selectedHeader.length > 0, selectedDistricts.length > 0, selectedAPMCs.length > 0, dateFrom, dateTo, searchQuery].filter(Boolean).length} filter(s) active                    </span>
                  )}

                  <button className="btn btn-outline-secondary" onClick={() => setIsFilterOpen(false)}>
                    Cancel
                  </button>

                  <button 
                    className="btn btn-info" 
                    onClick={handleApplyFilters}
                    disabled={selectedHeader.length === 0}
                  >
                    Apply Filters
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {loading && (
        <div className="alert alert-info text-center py-5">
          <div className="spinner-border text-info mb-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <h5>Loading data...</h5>
        </div>
      )}

      {!loading && !hasAppliedFilter && (
        <div className="alert alert-info text-center py-5">
          <i className="bi bi-funnel display-4 d-block mb-3"></i>
          <h5>Please select filters and click "Apply Filters" to view data</h5>
<p className="text-muted">Choose Report Type and Date Range (required), then click Apply Filters</p>        </div>
      )}

      {!loading && hasAppliedFilter && !hasData && (
        <div className="alert alert-warning text-center py-5">
          <i className="bi bi-exclamation-triangle display-4 d-block mb-3"></i>
          <h5>No data found matching the selected filters</h5>
          <p className="text-muted">Try adjusting your filter criteria</p>
        </div>
      )}

{!loading && hasData && Object.entries(groupedByTable).map(([tableName, tableData]) => {
  if (tableData.details.length === 0) return null;

  // Get the correct form structure for this specific table's header
  const misForm = getDataFieldByHeaderId(tableData.headerId);
  
  if (!misForm || misForm.length === 0) {
 
    
    // Get columns from first detail record
    const columns = Object.keys(tableData.details[0]).filter(key => 
      !['id', 'masterId', 'createdAt', 'updatedAt'].includes(key)
    );

    return (
      <div key={tableName} className="bg-white rounded shadow-sm p-4 mb-4">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h5 className="fw-bold text-dark mb-1">{tableData.headerName}</h5>
            <p className="text-muted mb-0 small">
              <i className="bi bi-exclamation-triangle me-2 text-warning"></i>
              Form structure not configured - showing raw data
            </p>
          </div>
          <span className="badge bg-warning text-dark">{tableData.details.length} Records</span>
        </div>

        <div className="table-responsive">
          <table className="table table-hover table-bordered align-middle">
            <thead className="table-warning">
              <tr>
                <th>Sr.No.</th>
                {columns.map(col => (
                  <th key={col}>{col.replace(/([A-Z])/g, ' $1').trim()}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.details.map((item, idx) => (
                <tr key={item.id || idx}>
                  <td>{idx + 1}</td>
                  {columns.map(col => (
                    <td key={col}>
                      {typeof item[col] === 'boolean' 
                        ? (item[col] ? 'Yes' : 'No')
                        : item[col] || '-'}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // Regular rendering with proper form structure
  return (
    <div key={tableName} className="bg-white rounded shadow-sm p-4 mb-4">
      <div className="d-flex justify-content-between align-items-start mb-3">
        <div>
          <h5 className="fw-bold text-dark mb-1">{tableData.headerName}</h5>
          <p className="text-muted mb-0 small">
            <i className="bi bi-calendar3 me-2"></i>
            Agricultural Produce Market Committees Report
          </p>
        </div>
        <span className="badge bg-success">{tableData.details.length} Records</span>
      </div>

      <div className="table-responsive">
        <table className="table table-hover table-bordered align-middle">
          <thead className="table-success">
            {/* First Header Row */}
            <tr>
              <th rowSpan={2} style={{ 
                minWidth: "50px", 
                verticalAlign: "middle",
                textAlign: "center", 
                border: "1px solid #a2a2a2ff"
              }}>
                Sr.No.
              </th>
              {misForm.map((field, index) => (
                <th
                  key={index}
                  colSpan={field.response.length > 1 ? field.response.length : undefined}
                  rowSpan={field.response.length === 1 ? 2 : undefined}
                  style={{
                    minWidth: "150px",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    textAlign: "center",
                    verticalAlign: "middle",
                    border: "1px solid #a2a2a2ff"
                  }}
                >
                  {field.fieldVal}
                </th>
              ))}
            </tr>
            
            {/* Second Header Row - Only for multi-response fields */}
            <tr>
              {misForm.map((field, fieldIndex) => (
                <React.Fragment key={fieldIndex}>
                  {field.response.length > 1 && field.response.map((resp, respIndex) => (
                    <th
                      key={respIndex}
                      style={{
                        minWidth: "120px",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        textAlign: "center",
                        border: "1px solid #a2a2a2ff"
                      }}
                    >
                      {resp.responseName}
                    </th>
                  ))}
                </React.Fragment>
              ))}
            </tr>
          </thead>

          <tbody>
            {tableData.details.map((item, index) => (
              <tr key={item.id || index}>
                <td style={{ textAlign: "center" }}>{index + 1}</td>
                {misForm.map((field, fieldIndex) => (
                  <React.Fragment key={fieldIndex}>
                    {field.response.map((resp, respIndex) => (
                      <td
                        key={respIndex}
                        style={{
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          padding: "0.75rem",
                        }}
                      >
                        {(() => {
                          const value = item[resp.fieldName as keyof typeof item];
                          
                          if (typeof value === 'boolean') {
                            return value ? 'Yes' : 'No';
                          }
                          
                          if (value === null || value === undefined) {
                            return '-';
                          }
                          
                          if (typeof value === 'number') {
                            return value.toString();
                          }
                          
                          return value || '-';
                        })()}
                      </td>
                    ))}
                  </React.Fragment>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
})}
    </div>
  );
};

export default MarketCommitteeDashboard;